module.exports = __webpack_public_path__ + "static/media/JUV-BNB.c232b889.svg";